import FileUploader from "@amodv/react-file-uploader";
import React, { useEffect, useState } from "react";
import { FileUploadTypeModel } from "../../../models/FileUploadModel";
import { initUploadDocuments } from "../../../models/startup/StartupModel";
import { UploadDocumentsModel } from "../../../models/startup/UploadDocumentsModel";
import { requestType, StartupUploadTypeEnum, StepperStartupEnum } from "../../../utils/Enums";
import { useErrorStateValue } from "../../../providers/ErrorProvider";
import ValidationMessage from "../../common/controls/ValidationMessage";
import { STARTUP_FILE_REMOVE, STARTUP_FILE_UPLOAD, NEW_EVALUATION_FILE, NODE_URL } from "../../../constants/api";
import { get, post } from "../../../effects/api/api.common";
import { useHistory } from "react-router-dom";
import error from '../../../images/error.svg';
import ConfirmationDialog from '../../common/controls/ConfirmationDialog';
import { getSessionStorageValue } from "../../../effects/utils/session-storage";
import pdf from "../../../images/PDF.svg";
import xls from "../../../images/xls.svg";
import doc from "../../../images/doc.svg";
import Allround from "../../../images/Allround.svg";
import { FaExclamationTriangle } from "react-icons/fa";
interface IUploadDocumentProps {
    stepper: any;
    uploadDocumentsModel: UploadDocumentsModel;
    tabIndex: number;
    onStepSave: (uploadDocuments: UploadDocumentsModel, stepIndex: number, request: number) => void;
    onChildUpdate: (uploadDocuments: UploadDocumentsModel) => void;
    onPreviousClick: () => void;
    errors: Array<string>;
    applicationId: string;
    apiCalled: boolean;
    disabledForm: any
}
interface IIKeyValueIndexer {
    [key: string]: boolean;
}
function UploadDocumentsComponent(props: IUploadDocumentProps) {
    const {
        stepper,
        onStepSave,
        onChildUpdate,
        uploadDocumentsModel,
        applicationId,
        apiCalled,
        disabledForm
    } = props;
    // @ts-ignore
    const [{ errors }, dispatchError] = useErrorStateValue();
    const [uploadDocuments, setUploadDocuments] = useState<UploadDocumentsModel>(
        initUploadDocuments
    );
    const [openUploadBlock, setOpenUploadBlock] = useState<IIKeyValueIndexer>();
    const [loader, setLoader] = useState(false);
    const [agreeTermsBlock, setAgreeTermsBlock] = useState(false);
    const [pitchFile, setPitchFile] = useState('');
    const [exceedFileSize, setExceedFileSize] = useState(false)
    const [showSISFSClosedModal, setShowSISFSClosedModal] = useState(false);

    const dismissSISFSModal = () => {
        setShowSISFSClosedModal(false);
    };
    useEffect(() => {
        setUploadDocuments(uploadDocumentsModel);
    }, [apiCalled, applicationId]);
    useEffect(() => {
        getExcelFilePath();
    }, [])
    const getExcelFilePath = () => {
        get(NEW_EVALUATION_FILE).then((response: any) => {
            setPitchFile(response.data.Sample_Pitch_Deck)
            if (!response.data) return;
        });
    }
    const onSave = (submitType: string) => {
        let updatedUploadDocuments = uploadDocuments as UploadDocumentsModel;
        if (submitType === "submit") {
            updatedUploadDocuments.action = "submit";
        }
        onStepSave(updatedUploadDocuments, StepperStartupEnum.UploadDocuments, submitType === "submit" ? requestType.submit : requestType.save);
    };
    const history = useHistory();
    const [popUpName, setPopUpName] = useState("");
    const setMeetingModal = (fieldName: string) => {
        setPopUpName(fieldName);
    };
    const applicationPage = () => {
        history.push({
            pathname: "/startup_status",
        });
    }
    const onFileUploadComplete = (files: Array<File>, type: string) => {
        let indexes: Array<string> = [];
        let updatedUploadDocuments = Object.assign({}, uploadDocuments);
        for (const file of files) {
            let updatedFileData: Array<FileUploadTypeModel> = [];
            const user: any = getSessionStorageValue("user");
            const userInfo = JSON.parse(user)
            const formData = new FormData();
            formData.append("file", file);
            formData.append("application_id", applicationId.toString());
            formData.append("file_type", type);
            formData.append("logged_user_id", userInfo.id)
            setLoader(true);
            post(STARTUP_FILE_UPLOAD, formData).then((response: any) => {
                setLoader(false);
                if (!response.data) return;
                if (response.data.result.message == "Only single file should be uploaded for pitch deck." || response.data.result.message == "File already exists.") {
                    setFailDialogData({
                        "header": "Oops",
                        "text": response.data.result.message
                    })
                    setShowIncubatorFailureModal1(true);
                    return;
                } else {
                    switch (type) {
                        case StartupUploadTypeEnum.UploadPitchDeck:
                            updatedFileData = [
                                ...updatedUploadDocuments.upload_pitch_deck.map((uf: any): FileUploadTypeModel => { return new FileUploadTypeModel(uf.file_id, uf.file_type, uf.file) }),
                                new FileUploadTypeModel(response.data.result.file_id, StartupUploadTypeEnum.UploadPitchDeck, file)
                            ];
                            updatedUploadDocuments.upload_pitch_deck = updatedFileData
                            setUploadDocuments(prevState => {
                                const updatedFileOther = {
                                    ...prevState,
                                    relavent_document_excel: [
                                        ...prevState.upload_pitch_deck.map((uf: any): FileUploadTypeModel => { return new FileUploadTypeModel(uf.file_id, uf.file_type, uf.file) }),
                                        new FileUploadTypeModel(response.data.result.file_id, StartupUploadTypeEnum.UploadPitchDeck, file)
                                    ]
                                }
                                return updatedFileOther;
                            });
                            setLocalStateAndUpdateParent(updatedUploadDocuments);
                            break;
                        case StartupUploadTypeEnum.UploadVideoForProduct:
                            updatedFileData = [
                                ...updatedUploadDocuments.upload_video_for_product.map((uf: any): FileUploadTypeModel => { return new FileUploadTypeModel(uf.file_id, uf.file_type, uf.file) }),
                                new FileUploadTypeModel(response.data.result.file_id, StartupUploadTypeEnum.UploadVideoForProduct, file)
                            ];
                            updatedUploadDocuments.upload_video_for_product = updatedFileData
                            setUploadDocuments(prevState => {
                                const updatedFileOther = {
                                    ...prevState,
                                    relavent_document_excel: [
                                        ...prevState.upload_video_for_product.map((uf: any): FileUploadTypeModel => { return new FileUploadTypeModel(uf.file_id, uf.file_type, uf.file) }),
                                        new FileUploadTypeModel(response.data.result.file_id, StartupUploadTypeEnum.UploadVideoForProduct, file)
                                    ]
                                }
                                return updatedFileOther;
                            });
                            setLocalStateAndUpdateParent(updatedUploadDocuments);
                            break;
                        case StartupUploadTypeEnum.UploadRelaventDocumentOther:
                            updatedFileData = [
                                ...updatedUploadDocuments.upload_relavent_document_other.map((uf: any): FileUploadTypeModel => { return new FileUploadTypeModel(uf.file_id, uf.file_type, uf.file) }),
                                new FileUploadTypeModel(response.data.result.file_id, StartupUploadTypeEnum.UploadRelaventDocumentOther, file)
                            ];
                            updatedUploadDocuments.upload_relavent_document_other = updatedFileData
                            setUploadDocuments(prevState => {
                                const updatedFileOther = {
                                    ...prevState,
                                    relavent_document_excel: [
                                        ...prevState.upload_relavent_document_other.map((uf: any): FileUploadTypeModel => { return new FileUploadTypeModel(uf.file_id, uf.file_type, uf.file) }),
                                        new FileUploadTypeModel(response.data.result.file_id, StartupUploadTypeEnum.UploadRelaventDocumentOther, file)
                                    ]
                                }
                                return updatedFileOther;
                            });
                            setLocalStateAndUpdateParent(updatedUploadDocuments);
                            break;
                        default:
                            setLocalStateAndUpdateParent(updatedUploadDocuments);
                            break;
                    }
                    formData.delete("file");
                    formData.delete("application_id");
                    formData.delete("file_type");
                    setLoader(false);
                }
            });
        }
        if (indexes.length) {
            indexes.map((ind) => {
                const position: number = files.findIndex((file) => file.name === ind);
                files.splice(position, 1);
            });
        }
    };
    const onFileUploadCompleteRelevent = (files: Array<File>, type: string) => {
        let indexes: Array<string> = [];
        let updatedUploadDocuments = Object.assign({}, uploadDocuments);
        if (files.length > 10) {
            setShowIncubatorFailureModal(true);
            return;
        } else if (files.length <= 10) {
            for (const file of files) {
                let updatedFileData: Array<FileUploadTypeModel> = [];
                const formData = new FormData();
                const user: any = getSessionStorageValue("user");
                const userInfo = JSON.parse(user)
                formData.append("file", file);
                formData.append("application_id", applicationId.toString());
                formData.append("file_type", type);
                formData.append("logged_user_id", userInfo.id)
                setLoader(true);
                post(STARTUP_FILE_UPLOAD, formData).then((response: any) => {
                    setLoader(false);
                    if (!response.data) return;
                    if (response.data.result.message == "File already exists.") {
                    } else {
                        switch (type) {
                            case StartupUploadTypeEnum.UploadPitchDeck:
                                updatedFileData = [
                                    ...updatedUploadDocuments.upload_pitch_deck.map((uf: any): FileUploadTypeModel => { return new FileUploadTypeModel(uf.file_id, uf.file_type, uf.file) }),
                                    new FileUploadTypeModel(response.data.result.file_id, StartupUploadTypeEnum.UploadPitchDeck, file)
                                ];
                                updatedUploadDocuments.upload_pitch_deck = updatedFileData
                                setUploadDocuments(prevState => {
                                    const updatedFileOther = {
                                        ...prevState,
                                        relavent_document_excel: [
                                            ...prevState.upload_pitch_deck.map((uf: any): FileUploadTypeModel => { return new FileUploadTypeModel(uf.file_id, uf.file_type, uf.file) }),
                                            new FileUploadTypeModel(response.data.result.file_id, StartupUploadTypeEnum.UploadPitchDeck, file)
                                        ]
                                    }
                                    return updatedFileOther;
                                });
                                setLocalStateAndUpdateParent(updatedUploadDocuments);
                                break;
                            case StartupUploadTypeEnum.UploadVideoForProduct:
                                updatedFileData = [
                                    ...updatedUploadDocuments.upload_video_for_product.map((uf: any): FileUploadTypeModel => { return new FileUploadTypeModel(uf.file_id, uf.file_type, uf.file) }),
                                    new FileUploadTypeModel(response.data.result.file_id, StartupUploadTypeEnum.UploadVideoForProduct, file)
                                ];
                                updatedUploadDocuments.upload_video_for_product = updatedFileData
                                setUploadDocuments(prevState => {
                                    const updatedFileOther = {
                                        ...prevState,
                                        relavent_document_excel: [
                                            ...prevState.upload_video_for_product.map((uf: any): FileUploadTypeModel => { return new FileUploadTypeModel(uf.file_id, uf.file_type, uf.file) }),
                                            new FileUploadTypeModel(response.data.result.file_id, StartupUploadTypeEnum.UploadVideoForProduct, file)
                                        ]
                                    }
                                    return updatedFileOther;
                                });
                                setLocalStateAndUpdateParent(updatedUploadDocuments);
                                break;
                            case StartupUploadTypeEnum.UploadRelaventDocumentOther:
                                updatedFileData = [
                                    ...updatedUploadDocuments.upload_relavent_document_other.map((uf: any): FileUploadTypeModel => { return new FileUploadTypeModel(uf.file_id, uf.file_type, uf.file) }),
                                    new FileUploadTypeModel(response.data.result.file_id, StartupUploadTypeEnum.UploadRelaventDocumentOther, file)
                                ];
                                updatedUploadDocuments.upload_relavent_document_other = updatedFileData
                                setUploadDocuments(prevState => {
                                    const updatedFileOther = {
                                        ...prevState,
                                        relavent_document_excel: [
                                            ...prevState.upload_relavent_document_other.map((uf: any): FileUploadTypeModel => { return new FileUploadTypeModel(uf.file_id, uf.file_type, uf.file) }),
                                            new FileUploadTypeModel(response.data.result.file_id, StartupUploadTypeEnum.UploadRelaventDocumentOther, file)
                                        ]
                                    }
                                    return updatedFileOther;
                                });
                                setLocalStateAndUpdateParent(updatedUploadDocuments);
                                break;
                            default:
                                setLocalStateAndUpdateParent(updatedUploadDocuments);
                                break;
                        }
                        formData.delete("file");
                        formData.delete("application_id");
                        formData.delete("file_type");
                        setLoader(false);
                    }
                });
            }
        }
        if (indexes.length) {
            indexes.map((ind) => {
                const position: number = files.findIndex((file) => file.name === ind);
                files.splice(position, 1);
            });
        }
    };
    const [showIncubatorFailureModal, setShowIncubatorFailureModal] = useState(false);
    const [showIncubatorFailureModal1, setShowIncubatorFailureModal1] =
        useState(false);
    const [failDialogData, setFailDialogData] = useState({
        header: '',
        text: '',
    });
    const dismissModal = () => {
        setShowIncubatorFailureModal(false);
        setExceedFileSize(false)
    };
    const getFileDetails = (file: any, key: string) => {
        let file_name = '';
        file_name =
            file != undefined && file != null && file.length > 1
                ? file.substr(file.lastIndexOf('/') + 1, file.length)
                : '';
        const file_type = file != undefined && file != null && file.length > 1
            ? file.substr(
                file.lastIndexOf('.') + 1,
                file.length
            ) : '';
        if (key == 'name') return file_name;
        if (key == 'file') return file != undefined ? file.toString() : '';
        if (key == 'type') return file != undefined ? file_type.toString() : '';
    };
    const onFileDelete = (file: File, type: string) => {
        console.log(file.name, "laaaankeeee")
        const {
            upload_pitch_deck,
            upload_video_for_product,
            upload_relavent_document_other
        } = uploadDocuments;
        let remainingFiles: Array<FileUploadTypeModel> = [];
        let fileToBeDeleted: any;
        switch (type) {
            case StartupUploadTypeEnum.UploadPitchDeck:
                fileToBeDeleted = upload_pitch_deck.find(
                    (uploadedFile: FileUploadTypeModel) =>
                        getFileDetails(uploadedFile.file, 'name') === file.name
                );
                if (!fileToBeDeleted) return;
                remainingFiles = upload_pitch_deck.filter(
                    (uf: FileUploadTypeModel) =>
                        uf.file !== fileToBeDeleted.file
                );
                uploadDocuments.upload_pitch_deck = remainingFiles;
                setLocalStateAndUpdateParent(uploadDocuments);
                break;
            case StartupUploadTypeEnum.UploadVideoForProduct:
                fileToBeDeleted = upload_video_for_product.find(
                    (uploadedFile: FileUploadTypeModel) => getFileDetails(uploadedFile.file, 'name') === file.name
                );
                if (!fileToBeDeleted) return;
                remainingFiles = upload_video_for_product.filter(
                    (uf: FileUploadTypeModel) => uf.file !== fileToBeDeleted.file
                );
                uploadDocuments.upload_video_for_product = remainingFiles;
                setLocalStateAndUpdateParent(uploadDocuments);
                break;
            case StartupUploadTypeEnum.UploadRelaventDocumentOther:
                fileToBeDeleted = upload_relavent_document_other.find(
                    (uploadedFile: FileUploadTypeModel) => getFileDetails(uploadedFile.file, 'name') === file.name
                );
                if (!fileToBeDeleted) return;
                remainingFiles = upload_relavent_document_other.filter(
                    (uf: FileUploadTypeModel) =>
                        uf.file !== fileToBeDeleted.file
                );
                uploadDocuments.upload_relavent_document_other = remainingFiles;
                setLocalStateAndUpdateParent(uploadDocuments);
                break;
        }
        const user: any = getSessionStorageValue("user");
        const userInfo = JSON.parse(user)
        setLoader(true);
        post(STARTUP_FILE_REMOVE, {
            application_id: applicationId,
            file_id: fileToBeDeleted.file_id,
            "logged_user_id": userInfo.id
        }).then((response: any) => {
            if (response.data) {
                setLoader(false);
            }
        });
    };
    const handleChange = (
        evt: React.ChangeEvent<
            HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement
        >
    ) => {
        const name = evt.target.name;
        const value = evt.target.value;
        let updatedUploadDocuments: UploadDocumentsModel = initUploadDocuments;
        updatedUploadDocuments = {
            ...uploadDocuments,
            [name]: value,
        };
        setLocalStateAndUpdateParent(updatedUploadDocuments);
    };
    const setLocalStateAndUpdateParent = (
        updatedUploadDocuments: UploadDocumentsModel
    ) => {
        setUploadDocuments(updatedUploadDocuments);
        setTimeout(() => {
            onChildUpdate(updatedUploadDocuments);
        }, 0);
    };
    const handleOnCheck = (e: any) => {
        const isChecked = e.target.checked;
        setAgreeTermsBlock(isChecked);
    };
    return (
        <>
            {loader &&
                <div className="spinner-border custom-spinner" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            }
            <fieldset disabled={loader}>
                <div className="form-content">
                    <div className="form-group required row">
                        <label className="col-sm-4 col-form-label">
                            Upload Pitch deck of your Business Idea
                        </label>
                        <div className="col-sm-8">
                            <div className="form-row">
                                <div className="col">
                                    <div className="d-inline-flex upload-pitch">
                                        <span className="link-orange-text link-underline">
                                            <a style={{ color: '#e26640' }}
                                                href={`${NODE_URL}` + pitchFile}
                                            >
                                                <u>Download Sample Pitch Deck</u>
                                            </a>
                                        </span>
                                    </div>
                                    <div className="">
                                        <fieldset disabled={disabledForm}>
                                            <button
                                                className="btn btn-sisfs btn-transparent-primary"
                                                onClick={() =>
                                                    setOpenUploadBlock({ RelevantUpload: true })
                                                }
                                            >
                                                Upload
                                            </button>
                                            {((openUploadBlock &&
                                                openUploadBlock["RelevantUpload"] &&
                                                uploadDocuments.upload_pitch_deck.length === 0) ||
                                                uploadDocuments.upload_pitch_deck.length > 0) && (
                                                    <>
                                                        <span
                                                            className="close"
                                                            onClick={() =>
                                                                setOpenUploadBlock({ RelevantUpload: false })
                                                            }
                                                        >
                                                            <i className="fa fa-close"></i>
                                                        </span>
                                                        <FileUploader
                                                            key={Math.random().toString()}
                                                            id={StartupUploadTypeEnum.UploadPitchDeck}
                                                            information="Drag & Drop the file or Browse"
                                                            fileType="application/pdf"
                                                            buttonLabel="Browse"
                                                            multiple={false}
                                                            enablePreview
                                                            IconComponent={() => (
                                                                <span className="fa fa-cloud-upload"></span>
                                                            )}
                                                            removeIconClass=""
                                                            existingFiles={
                                                                uploadDocuments.upload_pitch_deck.filter((item) => (item.file.size) <= 15 * 1024 * 1024).map(
                                                                    (uploadedFile: FileUploadTypeModel) =>
                                                                    ({
                                                                        name: getFileDetails(uploadedFile.file, 'name') || uploadedFile.file.name,
                                                                        url: uploadedFile.file
                                                                    })
                                                                ) as any
                                                            }
                                                            onUploadFinish={(files: Array<File>) => {
                                                                for (const file of files) {
                                                                    if (file.size <= 15 * 1024 * 1024) {
                                                                        onFileUploadComplete(
                                                                            files,
                                                                            StartupUploadTypeEnum.UploadPitchDeck
                                                                        );
                                                                    } else {
                                                                        setExceedFileSize(true);
                                                                        return;
                                                                    }
                                                                }
                                                            }}
                                                            onFileDelete={(deletedFile: File) =>
                                                                onFileDelete(
                                                                    deletedFile,
                                                                    StartupUploadTypeEnum.UploadPitchDeck
                                                                )
                                                            }
                                                        />
                                                    </>
                                                )}
                                        </fieldset>
                                        {(uploadDocuments.upload_pitch_deck.length > 0 && uploadDocuments.upload_pitch_deck[0].file.size == undefined) ? (
                                            <a
                                                className="incubator-details-link"
                                                data-toggle="modal"
                                                data-target="#showMorePitchDocuments"
                                                onClick={() => setMeetingModal("Upload PitchDeck")}
                                            >
                                                View uploaded Documents
                                            </a>
                                        ) : (
                                            ""
                                        )}
                                        <small>Supported file format - PDF only  |   Max. size: 15 MB</small>
                                    </div>
                                </div>
                            </div>
                            {errors &&
                                errors.UploadDocuments &&
                                errors.UploadDocuments["upload_pitch_deck"].length > 0 && (
                                    <ValidationMessage
                                        className="error"
                                        message={errors.UploadDocuments["upload_pitch_deck"]}
                                    />
                                )}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">
                            Video URL showcasing your product and/or business model
                            <small className="pt-1">( Optional )</small>
                        </label>
                        <div className="col-sm-8">
                            <input
                                type="text"
                                name="video_url_for_product"
                                className={
                                    errors &&
                                        errors.UploadDocuments &&
                                        errors.UploadDocuments["video_url_for_product"].length > 0
                                        ? "form-control error"
                                        : "form-control"
                                }
                                placeholder="Enter Video URL"
                                value={uploadDocuments.video_url_for_product}
                                disabled={disabledForm}
                                onChange={handleChange}
                                required={true}
                                maxLength={255}
                            />
                            {errors &&
                                errors.UploadDocuments &&
                                errors.UploadDocuments["video_url_for_product"].length > 0 && (
                                    <ValidationMessage
                                        className="error"
                                        message={errors.UploadDocuments["video_url_for_product"]}
                                    />
                                )}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">
                            Upload any other relevant document which can help us decide better
                            <small className="pt-1">( Optional )</small>
                        </label>
                        <div className="col-sm-8">
                            <div className="form-row">
                                <div className="col">
                                    <div className="">
                                        <fieldset disabled={disabledForm}>
                                            <button
                                                className="btn btn-sisfs btn-transparent-primary"
                                                onClick={() =>
                                                    setOpenUploadBlock({ RelevantOtherUpload: true })
                                                }
                                            >
                                                Upload
                                            </button>
                                            {((openUploadBlock &&
                                                openUploadBlock["RelevantOtherUpload"] &&
                                                uploadDocuments.upload_relavent_document_other.length === 0) ||
                                                uploadDocuments.upload_relavent_document_other.length > 0) && (
                                                    <>
                                                        <span
                                                            className="close"
                                                            onClick={() =>
                                                                setOpenUploadBlock({ RelevantOtherUpload: false })
                                                            }
                                                        >
                                                            <i className="fa fa-close"></i>
                                                        </span>
                                                        <FileUploader
                                                            key={Math.random().toString()}
                                                            id={StartupUploadTypeEnum.UploadRelaventDocumentOther}
                                                            information="Drag & Drop the file or Browse"
                                                            fileType="application/pdf"
                                                            buttonLabel="Browse"
                                                            multiple={true}
                                                            enablePreview
                                                            IconComponent={() => (
                                                                <span className="fa fa-cloud-upload"></span>
                                                            )}
                                                            removeIconClass=""
                                                            existingFiles={uploadDocuments.upload_relavent_document_other.filter((item) => (item.file.size) <= 15 * 1024 * 1024).map(
                                                                (uploadedFile: FileUploadTypeModel) =>
                                                                ({
                                                                    name: getFileDetails(uploadedFile.file, 'name') || uploadedFile.file.name,
                                                                    url: uploadedFile.file
                                                                })
                                                            ) as any}
                                                            onUploadFinish={(files: Array<File>) => {
                                                                for (const file of files) {
                                                                    if (file.size <= 15 * 1024 * 1024) {
                                                                        onFileUploadCompleteRelevent(
                                                                            files,
                                                                            StartupUploadTypeEnum.UploadRelaventDocumentOther
                                                                        );
                                                                    } else {
                                                                        setExceedFileSize(true);
                                                                        return;
                                                                    }
                                                                }
                                                            }}
                                                            onFileDelete={(deletedFile: File) =>
                                                                onFileDelete(
                                                                    deletedFile,
                                                                    StartupUploadTypeEnum.UploadRelaventDocumentOther
                                                                )
                                                            }
                                                        />
                                                    </>
                                                )}
                                        </fieldset>
                                        {(uploadDocuments.upload_relavent_document_other.length > 0 && uploadDocuments.upload_relavent_document_other[0].file.size == undefined) ? (
                                            <a
                                                className="incubator-details-link"
                                                data-toggle="modal"
                                                data-target="#showMorePitchDocuments"
                                                onClick={() => setMeetingModal("Upload Relavant Doc")}
                                            >
                                                View uploaded Documents
                                            </a>
                                        ) : (
                                            ""
                                        )}
                                        <small>Supported file format - PDF only  |   Max. size: 15 MB</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <fieldset disabled={disabledForm}>
                        <div className="form-group row">
                            <div className="col-sm-12">
                                <div className="agree-confirm-box">
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="agreeincubatorapplication"
                                            name="agreeincubatorapplication"
                                            checked={agreeTermsBlock}
                                            onChange={handleOnCheck}
                                        />
                                        <label
                                            className="custom-control-label"
                                            htmlFor="agreeincubatorapplication"
                                        >
                                            We are in compliance with the provisions of the various
                                            Acts, Rules, Regulations, Guidelines, Standards applicable
                                            to the entity from time to time. All information provided by
                                            us in the application is true, correct and complete and no
                                            information material to the subject matter of this form has
                                            been suppressed or concealed. If there is any change in this
                                            information or compliance status, I will duly inform Startup
                                            India within 15 days on{" "}
                                            <a href="mailto:dipp-startups@nic.in">
                                                <u className="link-orange-text">dipp-startups@nic.in</u>
                                            </a>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>
                <fieldset disabled={disabledForm}>
                    <div className="stepper-footer-section">
                        <div
                            className="btn-toolbar justify-content-between"
                            role="toolbar"
                            aria-label="Toolbar with button groups"
                        >
                            <button className="btn btn-sisfs btn-transparent-primary" onClick={() => applicationPage()}>
                                Cancel
                            </button>
                            <span className="stepper-page-count">Step {props.tabIndex} / 7 </span>
                            <div className="btn-group">
                                {props.tabIndex != 1 && (
                                    <button
                                        className="btn btn-sisfs btn-transparent-primary"
                                        onClick={props.onPreviousClick}
                                    >
                                        Previous
                                    </button>
                                )}
                                <button
                                    type="button"
                                    className="btn btn-sisfs btn-yellow-primary"
                                    onClick={() => onSave("")}
                                >
                                    {props.tabIndex == 7 ? "Save" : "Save And Next"}
                                </button>
                                {props.tabIndex == 7 && (
                                    <button
                                        className="btn btn-sisfs btn-yellow-primary"
                                        disabled={!agreeTermsBlock}
                                        onClick={() => setShowSISFSClosedModal(true)}
                                    >
                                        Submit
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </fieldset>
            </fieldset>
            {showIncubatorFailureModal1 && (
                <ConfirmationDialog
                    headerText={failDialogData.header}
                    bodyText={failDialogData.text}
                    onDialogClose={() => setShowIncubatorFailureModal1(false)}
                    iconClass="showImage"
                />
            )}
            {showSISFSClosedModal && (
                <div
                    className="modal align-middle modal-sisfs d-block"
                    id="SISFSClosedModal"
                    style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                >
                    <div className="modal-dialog modal-dialog-centered modal-md">
                        <div
                            className="modal-content"
                            style={{
                                border: "2px solid #f0c14b",
                                borderRadius: "12px",
                                boxShadow: "0 0 20px rgba(240,193,75,0.4)"
                            }}
                        >
                            <div
                                className="modal-body text-center"
                                style={{ padding: "30px" }}
                            >
                                {/* Warning Icon */}
                                <div className="mb-3">
                                    <FaExclamationTriangle
                                        size={45}
                                        color="#f39c12"
                                    />
                                </div>

                                {/* Heading */}
                                <h3
                                    style={{
                                        color: "#e26640",
                                        fontWeight: "bold",
                                        fontFamily: "Roboto Slab",
                                        marginBottom: "20px"
                                    }}
                                >
                                    Notice
                                </h3>

                                <hr
                                    style={{
                                        borderTop: "1px dashed #f0c14b",
                                        marginBottom: "20px"
                                    }}
                                />

                                {/* Message */}
                                <div
                                    style={{
                                        textAlign: "center",
                                        lineHeight: "1.8",
                                        fontSize: "15px",
                                        color: "#444"
                                    }}
                                >
                                    <p>
                                        Please note that the application window for the
                                        Startup India Seed Fund Scheme (SISFS) closed on
                                        <strong> 31 May 2026 at 11:59 PM (IST)</strong>.
                                        New startup applications can no longer be submitted
                                        through the portal.
                                    </p>

                                    <p>
                                        If you have already submitted an application on or
                                        before the deadline, it will continue to be
                                        processed by the concerned incubator as per the
                                        scheme timelines.
                                    </p>

                                    <p>
                                        Incubators may complete the startup selection
                                        process until <strong>30 June 2026</strong>.
                                    </p>
                                </div>

                                {/* Button */}
                                <div className="modal-action mt-4">
                                    <button
                                        className="btn btn-sisfs btn-yellow-primary"
                                        onClick={() =>
                                            setShowSISFSClosedModal(false)
                                        }
                                        style={{
                                            minWidth: "100px",
                                            fontWeight: "bold"
                                        }}
                                    >
                                        OK
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showIncubatorFailureModal && (
                <div
                    className="modal align-middle modal-sisfs d-block"
                    id="FormSubmissionError"
                >
                    <div className="modal-dialog modal-dialog-centered modal-md">
                        <div className="modal-content">
                            <div className="modal-body text-center">
                                <img
                                    src={error}
                                    className="search mb-2"
                                    alt="search"
                                />
                                <h4 className="message-orange" style={{ fontWeight: "bold", fontFamily: "Roboto Slab" }}>
                                    Oops!!!
                                </h4>
                                <h4 className="message-orange" style={{ fontWeight: "bold", fontFamily: "Roboto Slab" }}>
                                    Please Try Again !!!<br /><br />
                                    Only 10 files can be uploaded once
                                </h4>
                                <div className="modal-action">
                                    <button
                                        className="btn btn-sisfs btn-yellow-primary"
                                        onClick={dismissModal}
                                    >
                                        OK !
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {exceedFileSize && (
                <div
                    className="modal align-middle modal-sisfs d-block"
                    id="FormSubmissionError"
                >
                    <div className="modal-dialog modal-dialog-centered modal-md">
                        <div className="modal-content">
                            <div className="modal-body text-center">
                                <img
                                    src={error}
                                    className="search mb-2"
                                    alt="search"
                                    style={{ width: '2rem' }}
                                />
                                <h4 className="message-orange" style={{ fontFamily: "Roboto Slab" }}>
                                    Oops!!!
                                </h4>
                                <h5 className="message-orange" style={{ fontFamily: "Roboto Slab" }}>
                                    File size should not exceed 15Mb<br /><br />
                                    Please upload again.
                                </h5>
                                <div className="modal-action">
                                    <button
                                        className="btn btn-sisfs btn-yellow-primary"
                                        onClick={dismissModal}
                                    >
                                        OK !
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div
                className="modal fade"
                id="showMorePitchDocuments"
                role="dialog"
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
            >
                <div
                    className="modal-dialog modal-dialog-centered modal-md"
                    role="document"
                >
                    <div className="modal-content">
                        <div className="modal-header modal-header-border-none ml-18px">
                            <h5 className="modal-title " id="exampleModalLongTitle">
                                {popUpName} <span className="eac-name-pop-up"></span>
                            </h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {popUpName == "Upload PitchDeck" ? (
                                uploadDocuments.upload_pitch_deck != undefined ? (
                                    uploadDocuments.upload_pitch_deck.map(
                                        (file: any, index: any) => (
                                            <div className="row">
                                                <div className="col-md-2">
                                                    {getFileDetails(file.file, "type") == "pdf" ? (
                                                        <img src={pdf} alt="SISFS Logo" />
                                                    ) : getFileDetails(file.file, "type") == "doc" ? (
                                                        <img src={doc} alt="SISFS Logo" />
                                                    ) : getFileDetails(file.file, "type") == "xls" ? (
                                                        <img src={xls} alt="SISFS Logo" />
                                                    ) : (
                                                        <img src={Allround} alt="SISFS Logo" />
                                                    )}
                                                </div>
                                                <div className="col-md-9 left-align">
                                                    <span className="document-label-value-wrap">
                                                        {getFileDetails(file.file, "name") || file.file.name}
                                                    </span>
                                                    <br />
                                                    <a
                                                        href={file.file}
                                                        target="_blank"
                                                        className="incubator-details-link"
                                                    >
                                                        View
                                                    </a>
                                                </div>
                                            </div>
                                        )
                                    )
                                ) : (
                                    <span className="incubator-label-value">-</span>
                                )
                            ) : (
                                ""
                            )}
                            {popUpName == "Upload Relavant Doc" ? (
                                uploadDocuments.upload_relavent_document_other != undefined ? (
                                    uploadDocuments.upload_relavent_document_other.map(
                                        (file: any, index: any) => (
                                            <div className="row">
                                                <div className="col-md-2">
                                                    {getFileDetails(file.file, "type") == "pdf" ? (
                                                        <img src={pdf} alt="SISFS Logo" />
                                                    ) : getFileDetails(file.file, "type") == "doc" ? (
                                                        <img src={doc} alt="SISFS Logo" />
                                                    ) : getFileDetails(file.file, "type") == "xls" ? (
                                                        <img src={xls} alt="SISFS Logo" />
                                                    ) : (
                                                        <img src={Allround} alt="SISFS Logo" />
                                                    )}
                                                </div>
                                                <div className="col-md-9 left-align">
                                                    <span className="document-label-value-wrap">
                                                        {getFileDetails(file.file, "name") || file.file.name}
                                                    </span>
                                                    <br />
                                                    <a
                                                        href={file.file}
                                                        target="_blank"
                                                        className="incubator-details-link"
                                                    >
                                                        View
                                                    </a>
                                                </div>
                                            </div>
                                        )
                                    )
                                ) : (
                                    <span className="incubator-label-value">-</span>
                                )
                            ) : (
                                ""
                            )}
                            <div className="row">
                                <div className="col-md-12 centerText">
                                    <div className="btn-group mt-1-5 ">
                                        <button
                                            className="tertiary  btn-yellow-primary"
                                            data-dismiss="modal"
                                        >
                                            OK
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UploadDocumentsComponent;